import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-liw',
  templateUrl: './liw.component.html',
  styleUrl: './liw.component.scss',
  standalone: true,
  imports: [CommonModule],
})

export class LiwComponent implements OnInit, AfterViewInit {
  token = '';
  gameName = '';
  @ViewChild('magicwin_container')

  container!: ElementRef;
  constructor(private route: ActivatedRoute, private titleService: Title) {
    this.titleService.setTitle('Lotto Instant Win');
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.token = params.get('token')!;
      this.gameName = params.get('gamename')!;
    });
  }

  ngAfterViewInit(): void {
    this.clearLottoScript();
    const container = document.getElementById('magicwin_container');
    if (container) {
      const externalScript = document.createElement('script');
      externalScript.type = 'text/javascript';
      externalScript.src = environment.lotto_instant_win.url;

      externalScript.onload = () => {
        const inlineScript = document.createElement('script');
        inlineScript.type = 'text/javascript';
        inlineScript.text = `
                var setup = {
                    container: "magicwin_container",
                    lang: "en",
                    runFrom: 4,
                    options: {
                        game: "${this.gameName}",
                        defaultCurrency: "ZAR",
                        skin: 2,
                        oddCulture: 0
                    },
                    UserToken: "${this.token}",
                    onLoad: function(instance) {
                        console.log("Game is loaded.");
                    },
                    onChangeBalance: function() {
                        console.log("Balance is changed");
                    }
                };
                MagicGames.addWidget(setup);
              `;

        container.appendChild(inlineScript);
      };

      container.appendChild(externalScript);
    }
  }
  private clearLottoScript() {
    const lottoDiv = document.getElementById("magicwin_container");
    if (lottoDiv) {
      const parent = lottoDiv?.parentElement;
      parent?.removeChild(lottoDiv);

      const newLottoWidget = document.createElement("div");
      newLottoWidget.id = "magicwin_container";
      parent?.appendChild(newLottoWidget);
    }
  }

}
